import { ComponentType } from "react";
import { Scope } from "../types";

// Standard A2UI v0.9 catalog
import { Avatar } from "./custom/Avatar";
import { AudioPlayer } from "./standard/AudioPlayer";
import { Button } from "./standard/Button";
import { Card } from "./standard/Card";
import { CheckBox } from "./standard/CheckBox";
import { Column } from "./standard/Column";
import { DateTimeInput } from "./standard/DateTimeInput";
import { Divider } from "./standard/Divider";
import { Icon } from "./standard/Icon";
import { Image } from "./standard/Image";
import { List } from "./standard/List";
import { Modal } from "./standard/Modal";
import { MultipleChoice } from "./standard/MultipleChoice";
import { Row } from "./standard/Row";
import { Slider } from "./standard/Slider";
import { Tabs } from "./standard/Tabs";
import { Text } from "./standard/Text";
import { TextField } from "./standard/TextField";
import { Video } from "./standard/Video";

// BeX custom catalog additions
import { DataTable } from "./custom/DataTable";
import { FileUpload } from "./custom/FileUpload";
import { Form } from "./custom/Form";
import { Notification } from "./custom/Notification";
import { ProgressIndicator } from "./custom/ProgressIndicator";
import { StatusBadge } from "./custom/StatusBadge";
import { Stepper } from "./custom/Stepper";
import { Turnstile } from "./custom/Turnstile";

export interface ComponentProps {
  id: string;
  fields: Record<string, unknown>;
  scope: Scope;
}

export const COMPONENTS: Record<string, ComponentType<ComponentProps>> = {
  // Standard
  Row, Column, List, Card, Tabs, Divider, Modal,
  Text, Image, Icon, Video, AudioPlayer,
  Button,
  TextField, CheckBox, DateTimeInput, MultipleChoice, Slider,

  // BeX custom
  Turnstile, DataTable, Form, Stepper, ProgressIndicator,
  StatusBadge, Avatar, FileUpload, Notification,
};
